import { useState } from 'react';

import MultiStepMessage from './MultiStepMessage';
import { appendStreamedEventToMultiStepAnswer } from 'store/modules/chat-messages';
import DiscoveryAnswerFooter from '../DiscoveryAnswerFooter';

// MultiStepMessage as used in discovery (in contrast to the ChatMultiStepMessage, the child answers are not on the
//  redux state but held on a local state in this component)
const DiscoveryMultiStepMessage = ({ message, transferToChat }) => {
  // local state for the child answers
  const [childAnswers, setChildAnswers] = useState([]);

  // needs to be a promise such that it is awaitable
  const addChildAnswer = async event => {
    return new Promise(resolve => {
      setChildAnswers(prev => appendStreamedEventToMultiStepAnswer(message.answerId, event, prev));
      resolve(); // Immediately resolve after scheduling the update
    });
  };

  return (
    <MultiStepMessage
      answerId={message.answerId}
      questionId={message.questionId}
      childAnswers={childAnswers}
      addChildAnswer={addChildAnswer}
      useScrollBuffer={false}
      disableAnswerFootersAndTrailers
      // Allow to open this in chat
      // Similar to switching to a different example, the message in the chat will fetch the stream again,
      // and thus it works even though the child answers are not in the redux store
      customLastFooter={<DiscoveryAnswerFooter callback={transferToChat} />}
    />
  );
};

export default DiscoveryMultiStepMessage;
